import InfiniteLoader from 'react-window-infinite-loader'
import { VirtualizedListBase } from './virtualized-list-base'
import { virtualizedListDefaultProps } from './constant'
import { VirtualizedInfiniteListProps } from './virtualized-list.types'

export function VirtualizedInfiniteList<Item>({
  items = [],
  loadMore,
  hasMoreItemToLoad,
  loading = false,
  ...other
}: VirtualizedInfiniteListProps<Item>) {
  const isItemLoaded = (index: number) =>
    !hasMoreItemToLoad || index < items.length

  const itemCount =
    loading || !hasMoreItemToLoad ? items.length : items.length + 1

  return (
    <InfiniteLoader
      itemCount={itemCount}
      isItemLoaded={isItemLoaded}
      loadMoreItems={loadMore}
    >
      {({ onItemsRendered, ref }) => (
        <VirtualizedListBase
          {...other}
          ref={ref}
          onItemsRendered={onItemsRendered}
          items={items}
          itemCount={itemCount}
          loading={loading}
        />
      )}
    </InfiniteLoader>
  )
}

VirtualizedInfiniteList.defaultProps = virtualizedListDefaultProps
